import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { translateFormFieldLabel } from '../../../../../../helpers/collaborativeIndexations'

class Profession extends Component
{
    static propTypes = {
        t: PropTypes.func.isRequired,
        updateFieldValue: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
        hasFocus: PropTypes.bool,
    }

    constructor(props)
    {
        super(props)

        this.handleOnChange = this.handleOnChange.bind(this)
        this.mainField = React.createRef()
    }

    componentDidMount()
    {
        if(this.props.hasFocus === true)
        {
            this.mainField.current.focus()
        }
    }

    handleOnChange(event)
    {
        this.props.updateFieldValue("profession", event.target.value)
    }

    render()
    {
        const { t, fields } = this.props

        return (
            <div className={"form-group"}>
                <label>{translateFormFieldLabel(t, "profession")}</label>
                <input ref={this.mainField} defaultValue={fields.profession} onChange={this.handleOnChange} type={"text"} />
            </div>
        )
    }
}

export default withTranslation()(Profession)
